/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Action Imports */

import { fetchServiceLeads } from "../../../redux-components/Actions";

/* Component Imports */

import Autocomplete from "@material-ui/lab/Autocomplete";
import MuiAlert from "@material-ui/lab/Alert";
import {
  Typography,
  Paper,
  TextField,
  Button,
  Grid,
  Link,
  Checkbox,
  Snackbar,
  FormControlLabel,
} from "@material-ui/core";

/* Redux Imports */

import { connect } from "react-redux";

/* Data Imports */

import AppConfig from "../../../../AppConfig";

const useStyles = makeStyles((theme) => ({
  sectionContainer: {
    margin: "2rem 0rem 2rem 0rem",
  },
  contactPaper: {
    padding: "2rem 1.5rem 2rem 1.5rem",
    [theme.breakpoints.up("md")]: {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  contactForm: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "space-between",
    width: "100%",
  },
  textField: {
    margin: "0rem 0rem 2rem 0rem",
    width: "100%",
  },
  grey: {
    color: "#202020",
  },
  link: {
    color: "#037DBB",
    textDecoration: "none",
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  primaryButton: {
    width: "25%",
    margin: "1rem 0rem 0rem 0rem",
    color: "#FFFFFF",
    background: "-webkit-linear-gradient(#F74134, #EB1C61)",
  },
  heading: {
    width: "100%",
    color: "#000000",
    fontWeight: "400",
    fontSize: "2rem",
    lineHeight: "4.5rem",
    margin: "0rem 0rem 0.5rem 0rem",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
      lineHeight: "2.25rem",
    },
  },
  boldRed: {
    color: "#CC0000",
    fontWeight: "bold",
    background: "-webkit-linear-gradient(#F74134, #EB1C61)",
    "-webkit-background-clip": "text",
    "-webkit-text-fillColor": "transparent",
  },
  checkboxRow: {
    paddingBottom: "1rem",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    [theme.breakpoints.up("lg")]: {
      alignItems: "center",
    },
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const ServiceProviderForm = (props) => {
  const classes = useStyles();

  const BHK = [
    { title: "Interior Designer", value: "Interior Designer" },
    { title: "Civil Contractor", value: "Civil Contractor" },
    { title: "Lawyer", value: "Lawyer" },
    { title: "Architect", value: "Architect" },
    { title: "RERA Professional", value: "RERA Professional" },
    { title: "Financial Advisor", value: "Financial Advisor" },
    { title: "Wealth Manager", value: "Wealth Manager" },
    { title: "Liaising Professional", value: "Liaising Professional" },
    { title: "Land Aggregator", value: "Land Aggregator" },
  ];

  const [loadingSnackbar, setLoadingSnackbar] = React.useState(false);
  const [successSnackbar, setSuccessSnackbar] = React.useState(false);
  const [errorSnackbar, setErrorSnackbar] = React.useState(false);

  const [name, setName] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [business_location, setbusinessLocation] = React.useState("");
  const [business_type, setbusinessType] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [atc, setAtc] = React.useState(false);
  const [whatsapp, setWhatsapp] = React.useState(false);

  const submitForm = () => {
    const reqURL = encodeURI(
      AppConfig.apiUrlPrefix +
        "store-service-lead?name=" +
        name +
        "&phone=" +
        phone +
        "&email=" +
        email +
        "&business_location=" +
        business_location +
        "&business_type=" +
        business_type +
        "&message=" +
        message +
        "&agree=" +
        atc +
        "&whatsapp=" +
        whatsapp +
        "&source=" +
        (props.source ? props.source : "unknown")
    );
    setLoadingSnackbar(true);
    fetch(reqURL)
      .then((res) => {
        res
          .json()
          .then((data) => {
            setLoadingSnackbar(false);
            setSuccessSnackbar(true);
            if (typeof submitCallback === "function") submitCallback(data);
            /* TODO: Send Slack message with lead */
          })
          .catch((error) => {
            console.log(error);
            setLoadingSnackbar(false);
            setErrorSnackbar(true);
            if (typeof submitCallback === "function") submitCallback(error);
            /* TODO: Send Slack message with error */
          });
      })
      .catch((error) => {
        console.log(error);
        setLoadingSnackbar(false);
        setErrorSnackbar(true);
        if (typeof submitCallback === "function") submitCallback(error);
        /* TODO: Send Slack message with error */
      });
  };

  const handleLoadingSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setLoadingSnackbar(false);
  };
  const handleSuccessSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSuccessSnackbar(false);
  };
  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setErrorSnackbar(false);
  };

  return (
    <React.Fragment>
      <Snackbar
        open={loadingSnackbar}
        autoHideDuration={3000}
        onClose={handleLoadingSnackbarClose}
      >
        <Alert onClose={handleLoadingSnackbarClose} severity="info">
          Sending information...
        </Alert>
      </Snackbar>
      <Snackbar
        open={successSnackbar}
        autoHideDuration={3000}
        onClose={handleSuccessSnackbarClose}
      >
        <Alert onClose={handleSuccessSnackbarClose} severity="success">
          Thanks, {name}! We&apos;ll get in touch shortly.
        </Alert>
      </Snackbar>
      <Snackbar
        open={errorSnackbar}
        autoHideDuration={3000}
        onClose={handleErrorSnackbarClose}
      >
        <Alert onClose={handleErrorSnackbarClose} severity="error">
          Oops! Something seems to have gone wrong!
        </Alert>
      </Snackbar>
      <div className={classes.sectionContainer}>
        <Typography variant="h1" component="h1" className={classes.heading}>
          Enquire about <span className={classes.boldRed}>Services</span>
        </Typography>
        <Paper elevation={3} className={classes.contactPaper}>
          <form id="sf" className={classes.contactForm} method="GET">
            <Grid
              container
              spacing={2}
              justifyContent="center"
              alignItems="center"
            >
              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  id="name"
                  name="name"
                  label="Name"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setName(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  id="phone"
                  name="phone"
                  label="Phone Number"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setPhone(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  required={true}
                  type="email"
                  className={classes.textField}
                  onChange={(event) => {
                    setEmail(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <TextField
                  id="business_location"
                  name="business_location"
                  label="Address"
                  required={true}
                  type="text"
                  className={classes.textField}
                  onChange={(event) => {
                    setbusinessLocation(event.target.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <Autocomplete
                  options={BHK}
                  getOptionLabel={(option) => option.title}
                  getOptionSelected={(option) => option.title}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Type of Services"
                      name="business_type"
                      id="business_type"
                    />
                  )}
                  onChange={(event, value) => {
                    setbusinessType(value.value);
                    console.log(value.value);
                  }}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={12}>
                <TextField
                  id="message"
                  name="message"
                  label="Message"
                  required={true}
                  type="text"
                  multiline={true}
                  rows={3}
                  className={classes.textField}
                  onChange={(event) => {
                    setMessage(event.target.value);
                  }}
                />
              </Grid>
              <input
                id="source"
                type="hidden"
                name="source"
                value={props.source}
                onChange={(event) => {
                  setSource(event.target.value);
                }}
              ></input>
              <Grid item xs={12} md={12} lg={12}>
                <div className={classes.checkboxRow}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ padding: "0rem 0.5rem 0rem 0rem" }}
                        checked={whatsapp}
                        onChange={(event) => {
                          setWhatsapp(!whatsapp);
                        }}
                        color="primary"
                        value={whatsapp}
                        name="whatsapp"
                      />
                    }
                    label={
                      <span className={classes.grey}>
                        I would like to receive updates on WhatsApp
                      </span>
                    }
                  />
                </div>
                <div className={classes.checkboxRow}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        style={{ padding: "0rem 0.5rem 0rem 0rem" }}
                        checked={atc}
                        onChange={(event) => {
                          setAtc(!atc);
                        }}
                        color="primary"
                        value={atc}
                        name="agree"
                      />
                    }
                    label={
                      <span>
                        <span className={classes.grey}>
                          I have read and agree with the{" "}
                        </span>
                        <Link
                          href="/terms"
                          aria-label="Terms of Service"
                          title="Terms of Service"
                          rel="noopener"
                        >
                          Terms of Service{" "}
                        </Link>
                        and{" "}
                        <Link
                          href="/privacy"
                          aria-label="Privacy Policy"
                          title="Privacy Policy"
                          rel="noopener"
                        >
                          Privacy Policy
                        </Link>
                      </span>
                    }
                  />
                </div>
              </Grid>
            </Grid>
            <div className={classes.buttons}>
              <Button
                variant="contained"
                title="Submit"
                rel="noopener"
                className={classes.primaryButton}
                onClick={submitForm}
              >
                Submit
              </Button>
            </div>
          </form>
        </Paper>
      </div>
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  return {
    serviceLeads: state.serviceLeads,
  };
}

const mapDispatchToProps = {
  fetchServiceLeads,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProviderForm);
